import Indicadores from '@/services/Indicadores'

export default {
    // ----- Fatores -----
    getFactors(sectorId, stageId) {
        return Indicadores().get(`swot/factor/query/sector/${sectorId}/stage/${stageId}`)
    },
    getMatrix(sectorId, stageId) {
        return Indicadores().get(`swot/factor/matrix/sector/${sectorId}/stage/${stageId}`)
    },
    saveFactor(factor) {
        return Indicadores().post('swot/factor/save', factor)
    },
    updateFactor(factor) {
        return Indicadores().post('swot/factor/update', factor)
    },
    deleteFactor(id) {
        return Indicadores().delete(`swot/factor/delete/${id}`)
    },

    // ----- Objetivos -----
    getObjectives(sectorId, stageId) {
        return Indicadores().get(`swot/objective/query/sector/${sectorId}/stage/${stageId}`)
    },
    // Objetivos de todos os setores do stage (usado na Gestão de Objetivos)
    getAllObjectives(stageId) {
        return Indicadores().get(`swot/objective/query/stage/${stageId}`)
    },
    saveObjective(objective) {
        return Indicadores().post('swot/objective/save', objective)
    },
    updateObjective(objective) {
        return Indicadores().post('swot/objective/update', objective)
    },
    deleteObjective(id) {
        return Indicadores().delete(`swot/objective/delete/${id}`)
    },

    // ----- Iniciativas -----
    getInitiatives(sectorId, stageId) {
        return Indicadores().get(`swot/initiative/query/sector/${sectorId}/stage/${stageId}`)
    },
    saveInitiative(initiative) {
        return Indicadores().post('swot/initiative/save', initiative)
    },
    updateInitiative(initiative) {
        return Indicadores().post('swot/initiative/update', initiative)
    },
    deleteInitiative(id) {
        return Indicadores().delete(`swot/initiative/delete/${id}`)
    },

    // ----- Cruzamentos -----
    getCrossings(sectorId, stageId) {
        return Indicadores().get(`swot/crossing/query/sector/${sectorId}/stage/${stageId}`)
    },
    saveCrossing(crossing) {
        return Indicadores().post('swot/crossing/save', crossing)
    },
    updateCrossing(crossing) {
        return Indicadores().post('swot/crossing/update', crossing)
    },
    deleteCrossing(id) {
        return Indicadores().delete(`swot/crossing/delete/${id}`)
    }
}
